import { render, staticRenderFns } from "./EchangeForm.vue?vue&type=template&id=0e25b482"
import script from "./EchangeForm.vue?vue&type=script&lang=ts"
export * from "./EchangeForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports